import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as R from "ramda";
import styled from "styled-components";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import UpdatingSpinner from "../ui/UpdatingSpinner";
import {
  handleUpdatePassword,
  setShowUpdatePasswordModal,
} from "../login/userSession.redux";
import * as serialize from "form-serialize";

const labelStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};
const modalStyle = {
  borderBottom: "transparent",
};
const bodyStyle = {
  borderBottom: "transparent",
  padding: "0rem 1rem 1rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const formStyle = {
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "column",
};

const doubleButtonStyle = {
  width: "45px",
  height: "100%",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const inputStyle = {
  width: "100%",
  height: "30px",
};
const colStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};

const rowStyle = {
  display: "flex",
  alignItems: "center",
};

const rowContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const deleteButtonStyle = {
  color: "#F0142F",
  fontSize: 12,
  background: "none",
  border: "none",
};

const temporalButton = {
  width: "auto",
  height: "auto",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "30%",
};

//oval calculation button start
const ButtonCalculateOvalStyle = {
  borderColor: "white",
  backgroundColor: "#20358c",
  fontSize: "18px",
  height: "3em",
  textTransform: "uppercase",
};

const papUDButtonStyleActive = {
  backgroundColor: "#00147B",
  color: "#FFFFFF",
  border: "none",
};

const papUDButtonStyle = {
  backgroundColor: "#FFFFFF",
  color: "#00000099",
  border: "none",
};

const ButtonCalculateOval = ({ className, children, onClick }) => (
  <Button
    type="primary"
    size="large"
    className={className}
    style={ButtonCalculateOvalStyle}
    onClick={onClick}
  >
    {children}
  </Button>
);

const ModalRedux = (props) => {
  const [passwordError, setPasswordError] = useState("");
  const { t } = useTranslation();
  const formRef = useRef();

  const {
    updatingValues,
    handleUpdatePassword,
    showUpdatePasswordModal,
    setShowUpdatePasswordModal,
  } = props;

  const handleClose = () => {
    setShowUpdatePasswordModal({ show: false });
  };

  const handleUpdate = () => {
    const form = formRef.current;
    const values = serialize(form, { hash: true });
    if (values.password !== values.confirmPassword) {
      setPasswordError("message.error.password_confirmation");
    } else {
      setPasswordError("");
      handleUpdatePassword(values);
    }
  };

  return (
    <>
      <Modal
        show={showUpdatePasswordModal}
        onHide={handleClose}
        centered
        className={`select-modal password`}
      >
        <Modal.Header closeButton style={modalStyle}>
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div className="row">
              <span style={labelStyle}>
                <span style={{ marginRight: 5 }}>
                  {t(`form.label.change_password`)}
                </span>
              </span>
            </div>
            <div className="row">
              <span style={labelStyle}>
                <span
                  style={{ marginRight: 5, color: "red", fontSize: "10px" }}
                >
                  {passwordError !== "" ? t(passwordError) : ""}
                </span>
              </span>
            </div>
          </div>
        </Modal.Header>
        {updatingValues ? (
          <Modal.Body style={bodyStyle}>
            <UpdatingSpinner />
          </Modal.Body>
        ) : (
          <Modal.Body style={bodyStyle}>
            <Form ref={formRef} className="col-11">
              <Form.Group
                className="col-12 mb-2"
                controlId="exampleForm.ControlInput1"
                style={formStyle}
              >
                <div className="row" style={rowContainerStyle}>
                  <div className="col-10">
                    <div className="row form-floating" style={rowStyle}>
                      <div
                        className="col-12 form-floating mb-2"
                        style={{ padding: 0 }}
                      >
                        <Form.Control
                          type="password"
                          id="createAccountPasswordInput"
                          placeholder=""
                          autoFocus
                          name="password"
                        />
                        <label htmlFor="createAccountPasswordInput">
                          {t("form.placeholder.password")}
                        </label>
                      </div>
                    </div>
                    <div className="row form-floating" style={rowStyle}>
                      <div
                        className="col-12 form-floating mb-2"
                        style={{ padding: 0 }}
                      >
                        <Form.Control
                          id="createAccountVerifyPasswordInput"
                          type="password"
                          placeholder=""
                          autoFocus
                          name="confirmPassword"
                        />
                        <label htmlFor="createAccountVerifyPasswordInput">
                          {t("form.placeholder.verify_password")}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-2"
                    style={{ height: 90, padding: 0, paddingLeft: 3 }}
                  >
                    <Button onClick={handleUpdate} style={doubleButtonStyle}>
                      <FontAwesomeIcon icon={["fas", "arrow-down"]} />
                    </Button>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export const ModalPassword = connect(
  (state) => {
    return {
      updatingValues: state.api.requesting,
      showUpdatePasswordModal: state.userSession.showUpdatePasswordModal,
    };
  },
  {
    handleUpdatePassword,
    setShowUpdatePasswordModal,
  }
)(ModalRedux);
